export const SET_PERMISSION_ASSISTANCE_DIALOG_SHOWN =
  "permissions/SET_PERMISSION_ASSISTANCE_DIALOG_SHOWN";

export const setPermissionsAssistanceDialogShown = (open: boolean) => ({
  type: SET_PERMISSION_ASSISTANCE_DIALOG_SHOWN,
  isShown: open,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isShown = (state: any) =>
  state.permissionsAssistanceDialog?.isShown ?? false;

const initialState = {
  isShown: false,
};

export function permissionsAssistanceDialogReducer(
  state = initialState,
  action: ReturnType<typeof setPermissionsAssistanceDialogShown>,
) {
  if (action.type === SET_PERMISSION_ASSISTANCE_DIALOG_SHOWN) {
    return {
      ...state,
      isShown: action.isShown,
    };
  }

  return state;
}
